module.exports = __webpack_public_path__ + "img/avatar-default.b20dd9b.jpg";